import * as React from "react";

import { asString } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { ErrorBoundary } from "lib/error-boundary";

const VideoPlayer = lazilyLoadedComponent("video-player", () => import("../ui/smart/video-player/video-player"));

const fallbackStyle: React.CSSProperties = {
    height: 300,
};

export const VideoMaterialRenderer: GlideFunctionalRenderer = p => {
    const { getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[url]] = useForceValueProducers(getValueProducers, force, ctx);
    if (url === undefined || url === LOADING) return null;
    return (
        <ErrorBoundary>
            <React.Suspense fallback={<div style={fallbackStyle} />}>
                <VideoPlayer url={asString(url)} />
            </React.Suspense>
        </ErrorBoundary>
    );
};
